import React from 'react';

const Document = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 2.26946V6.4C14 6.96005 14 7.24008 14.109 7.45399C14.2049 7.64215 14.3578 7.79513 14.546 7.89101C14.7599 8 15.0399 8 15.6 8H19.7305M20 9.98822V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V6.8C4 5.11984 4 4.27976 4.32698 3.63803C4.6146 3.07354 5.07354 2.6146 5.63803 2.32698C6.27976 2 7.11984 2 8.8 2H12.0118C12.7455 2 13.1124 2 13.4577 2.08289C13.7638 2.15638 14.0564 2.27759 14.3249 2.44208C14.6276 2.6276 14.887 2.88703 15.4059 3.40589L18.5941 6.59411C19.113 7.11297 19.3724 7.3724 19.5579 7.67515C19.7224 7.94356 19.8436 8.2362 19.9171 8.5423C20 8.88757 20 9.25445 20 9.98822Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Document;

export const NewMobileDocumentIcon = () => {
  return (
    <svg
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.25 10.2695V14.4C22.25 14.9601 22.25 15.2401 22.359 15.454C22.4549 15.6422 22.6078 15.7951 22.796 15.891C23.0099 16 23.2899 16 23.85 16H27.9805M28.25 17.9882V25.2C28.25 26.8802 28.25 27.7202 27.923 28.362C27.6354 28.9265 27.1765 29.3854 26.612 29.673C25.9702 30 25.1302 30 23.45 30H17.05C15.3698 30 14.5298 30 13.888 29.673C13.3235 29.3854 12.8646 28.9265 12.577 28.362C12.25 27.7202 12.25 26.8802 12.25 25.2V14.8C12.25 13.1198 12.25 12.2798 12.577 11.638C12.8646 11.0735 13.3235 10.6146 13.888 10.327C14.5298 10 15.3698 10 17.05 10H20.2618C20.9955 10 21.3624 10 21.7077 10.0829C22.0138 10.1564 22.3064 10.2776 22.5749 10.4421C22.8776 10.6276 23.137 10.887 23.6559 11.4059L26.8441 14.5941C27.363 15.113 27.6224 15.3724 27.8079 15.6751C27.9724 15.9436 28.0936 16.2362 28.1671 16.5423C28.25 16.8876 28.25 17.2545 28.25 17.9882Z"
        stroke="#22CCEE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const NewSelectedMobileDocumentIcon = () => {
  return (
    <svg
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.25" width="40" height="40" rx="20" fill="#91bee7" />
      <path
        d="M22.25 10.2695V14.4C22.25 14.9601 22.25 15.2401 22.359 15.454C22.4549 15.6422 22.6078 15.7951 22.796 15.891C23.0099 16 23.2899 16 23.85 16H27.9805M28.25 17.9882V25.2C28.25 26.8802 28.25 27.7202 27.923 28.362C27.6354 28.9265 27.1765 29.3854 26.612 29.673C25.9702 30 25.1302 30 23.45 30H17.05C15.3698 30 14.5298 30 13.888 29.673C13.3235 29.3854 12.8646 28.9265 12.577 28.362C12.25 27.7202 12.25 26.8802 12.25 25.2V14.8C12.25 13.1198 12.25 12.2798 12.577 11.638C12.8646 11.0735 13.3235 10.6146 13.888 10.327C14.5298 10 15.3698 10 17.05 10H20.2618C20.9955 10 21.3624 10 21.7077 10.0829C22.0138 10.1564 22.3064 10.2776 22.5749 10.4421C22.8776 10.6276 23.137 10.887 23.6559 11.4059L26.8441 14.5941C27.363 15.113 27.6224 15.3724 27.8079 15.6751C27.9724 15.9436 28.0936 16.2362 28.1671 16.5423C28.25 16.8876 28.25 17.2545 28.25 17.9882Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
